import CabinetBuyCardContainer from 'components/views/UserCabinet/buy-card-page'
import Statement from 'components/views/UserCabinet/statement'
import useCheckStatus from 'hooks/useCheckStatus'
import LandingLayout from 'layout/landing-layout'
import { split } from 'ramda'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes } from 'react-router'
import { useLocation, useNavigate } from 'react-router-dom'
import { useShortLinkDecodeMutation } from 'redux/api/shortlink.api'
import { errorSelector } from 'redux/store/slices/error-slice'
// import { wsSelector } from 'redux/store/slices/websocket-slice'
import ProtectedRoute from 'routes/ProtectedRoute'
import { pathnames } from 'utils/steps'

import ClientErrorPage from './ClientErrorPage'
import IDNenterPage from './IDNenterPage'
import Landing from './Landing'
import LoadingPage from './LoadingPage'
import OfflineOtpPage from './OfflineOtpPage'
import OfflineSuccessPage from './OfflineSuccessPage'
import OtpVerifyPage from './OtpVerifyPage'
import PendingPage from './PendingPage'
import PhoneEnterActivationPage from './PhoneEnterActivationPage'
import UserPersonalCabinet from './UserPersonalCabinet'
// import Connecting from './steps/Connecting'

function Steps() {
  const error = useSelector(errorSelector)
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [fetchShortLinkDecode, { data: shortLinkDecodeData, error: shortLinkDecodeError }] =
    useShortLinkDecodeMutation()
  const [checkStatus] = useCheckStatus()
  useEffect(() => {
    if (split('/', location.pathname)[1] === 's') {
      fetchShortLinkDecode({ token: split('/', location.pathname)[2] })
        .unwrap()
        .then(data => {
          switch (data?.data?.service) {
            case 'ORDER_MEGA_CARD':
              checkStatus()
              break
            case 'VERIFY_OFFLINE_MEGA_CARD':
              // checkStatus()
              navigate(pathnames['offline-otp'])
              break
            default:
              break
          }
        })
    }
  }, [location.pathname, dispatch, fetchShortLinkDecode])

  useEffect(() => {
    if (error.code) {
      navigate(pathnames.error)
    }
  }, [error])

  return (
    <Routes>
      <Route element={<LandingLayout />}>
        <Route path='*' element={<Landing />} />

        <Route path={pathnames.error} element={<ClientErrorPage />} />
        <Route path={pathnames.pending} element={<PendingPage />} />
        <Route path={pathnames['activation-enter-phone']} element={<PhoneEnterActivationPage />} />
        <Route path={pathnames['otp-verify']} element={<OtpVerifyPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path={pathnames['idn-enter']} element={<IDNenterPage />} />
          <Route path={pathnames['activation-loading']} element={<LoadingPage />} />
          <Route path={pathnames['offline-otp']} element={<OfflineOtpPage />} />
          <Route path={pathnames['offline-success']} element={<OfflineSuccessPage />} />
          <Route path={pathnames['personal-cabinet']}>
            <Route index element={<UserPersonalCabinet />} />
            <Route path={pathnames['buy-card']} element={<CabinetBuyCardContainer />} />
            <Route path={pathnames.statement} element={<Statement />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}

export default Steps
